<template>
  <div>
    <label>Accepting New Clients: </label>
    <input-button-list
      :value="[acceptingNewClients]"
      :allow-two-stack="false"
      :multiple="false"
      label=""
      :force-full-width-inputs="false"
      :options="newClientsOptions"
      @input="setAcceptingNewClients($event)"
    />
  </div>
</template>

<script>
import CounselorClient from '@/api/CounselorClient';
import InputButtonList from '@/components/inputs/InputButtonList.vue';

export default {
    name: 'AccetpingNewClientsPicker',
    components: {
        InputButtonList,

    },
    props: {
        counselorId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            counselorClient: new CounselorClient(this.$http),
            acceptingNewClients: 'true',
            newClientsOptions: [{ id: 'true', display_label: 'Yes' },{ id: 'false', display_label: 'No' }]
        }
    },
    async mounted() {
        await this.counselorClient.getCounselorAcceptingNewClients(this.counselorId).then(res => {
            this.acceptingNewClients = `${res.acceptingNewClients}`;
      });
    },
    methods: {
        async setAcceptingNewClients(event) {
            const accepting = (event[0] === 'true');
            await this.counselorClient.setCounselorAcceptingNewClients(this.counselorId, accepting).catch(e => {
                console.error(e);
                this.$store.commit('setGlobalAlert', {
                    msg: 'Failed to set accepting new clients. Please try again!',
                    error: true
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>

label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

</style>
